import fetch from 'cross-fetch'
import Config from '../../config'
import PropTypes from 'prop-types'
import hasItems from '../has-items'
import consoleLogger from '../console-logger'

const FETCH_METHODS = {
  POST: 'POST',
  DELETE: 'DELETE',
}
const FETCH_VERSION = {
  V1: 'v1',
  V2: 'v2',
}
const actionPOST = ([actionArguments], props, signal) =>
  fetchData({ method: FETCH_METHODS.POST, ...props, ...actionArguments }, signal)
const actionMETHOD = ([actionArguments], props, signal) => fetchData({ ...props, ...actionArguments }, signal)
const [consoleLog] = consoleLogger('FetchData')
const fetchData = (
  { location, path, baseUrl, authUrl, version, access, method, data, onError = () => {}, onSuccess = () => {} },
  abortController,
) => {
  let fetchPath = path
  if (location) fetchPath = Config.restUrl(location, version)
  if (baseUrl) fetchPath = Config.baseUrl(baseUrl)
  if (authUrl) fetchPath = Config.authUrl(authUrl)
  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }
  if (abortController && hasItems(abortController.signal)) options['signal'] = abortController.signal
  if (access) options['headers']['Authorization'] = `Bearer ${access}`
  if (method) options['method'] = method
  if (data) options['body'] = JSON.stringify(data)
  consoleLog('fetch path', fetchPath)
  consoleLog('fetch options', options)
  return fetch(fetchPath, options).then((res) => {
    if (res.status >= 400 && res.status !== 401) {
      const error = { error: { http_status: res.status, message: 'Bad response from server' } }
      consoleLog('ERROR status >= 400', error)
      onError(error)
      throw new Error(`${error.error.http_status} - ${error.error.message}`)
    }
    consoleLog('SUCCESS')
    onSuccess(res)
    return res.json()
  })
}

fetchData.propTypes = {
  location: PropTypes.string,
  path: PropTypes.string,
  baseUrl: PropTypes.string,
  version: PropTypes.oneOf(Object.values(FETCH_VERSION)),
  access: PropTypes.string,
  method: PropTypes.oneOf(Object.values(FETCH_METHODS)),
  bodyData: PropTypes.object,
  onError: PropTypes.func,
}

fetchData.defaultProps = {
  onError: () => {},
}

export default fetchData

export { FETCH_METHODS, FETCH_VERSION, actionPOST, actionMETHOD }
